import room1 from '../images/roommate agreement/borrowing_rules.png'
import room2 from '../images/roommate agreement/cleaning_rules.png'
import room3 from '../images/roommate agreement/communication_and_pet_peeves.png'
import room4 from '../images/roommate agreement/conflict_resolution.png'
import room5 from '../images/roommate agreement/prohibited_items.png'
import room6 from '../images/roommate agreement/relevant_topics.png'
import room7 from '../images/roommate agreement/study_rules.png'
import room8 from '../images/roommate agreement/visitor_rules.png'

export const blogtext = 
<div className="blog-content" style={{backgroundColor: "lightblue", color: "#000", width:"100%", height:"100%", overflowY:"scroll",wordWrap:"normal", textAlign: "left", fontFamily: "serif"}}>

<b><i>Welcome to my blog. This window is scrollable.</i></b>

<br/>
<br/>


8/17/25
<br/>

A man who looked like an evil Will Ferrell just walked past Pike Place Market. I turned to my sister and she had the exact same
thought, which makes me wonder if we really did see Will Ferrell and he was just having a particularly terrible day.

<br/>
<br/>

8/10/25
<br/>
AN UNORDERED COLLECTION OF CURSED IDEAS I HAVE ACCUMULATED IN MY NOTES APP:
<ul>
    <li>A hat with ear holes</li>
    <li>A pie with either a bell pepper or an entire slice of charred and incinerated toast inside</li>
    <li>Meat flavored hint water</li>
    <li>Sticking as many phone holders as possible on a car and using them as a widescreen display</li>
    <li>A trombone with two degrees of freedom</li>
    <li>Getting your face tattooed on your face, but slightly smaller</li>
    <li>Keeping your bangs long and then cutting eyeholes in them</li>
    <li>Dyeing your hair either translucent, vantablack[the darkest chemically synthesized paint on earth], or skin tone</li>
    <li>A smell every smell in the world Guinness World Record speedrun category</li>
    <li>Carbonated clam chowder</li>
    <li>Homing smells- smells that once opened, pathfind their way to a target</li>
    <li>A fancy restaurant where they give you a single chopstick to eat soup with</li>
    <li>Slicing a potato by smashing it through the strings of a guitar</li>
    <li>Inflatable dobok that turns into sparring gear</li>
    <li>Hinged hard shell taco</li>
    <li>A pasta shape that is just a massive flaccid wheel with a million spokes so you think you’re eating a bowl of pasta but it’s just an absurdly long single pasta network</li>
</ul>


<br/>
<br/>

8/6/25
<br/>
I've been thinking about expanding my culinary palette and getting into slurries and gruels.
<br/>
<br/>

8/6/25
<br/>
<b>ROOMMATE AGREEMENT:</b>
<br/>
About a year ago, I moved into a new dorm suite with a few of my friends and we had to fill out a series of questions that 
would lay down the ground rules for how we should live and interact with each other. Here is what we ended up settling on:
<br/>
{/* <img width = "800" src = {room1}/> */}
<img width = "600" src = {room2}/>
<br/>
<img width = "600" src = {room3}/>
<br/>
<img width = "600" src = {room4}/>
<br/>
<img width = "600" src = {room5}/>
<br/>
<img width = "600" src = {room6}/>
<br/>
<img width = "600" src = {room7}/>
<br/>
<img width = "600" src = {room8}/>

<br/>
<br/>

8/5/25

<br/>
<br/>

We went to the Mattress Firm the other day to look at mattresses and we had the most incredible mattress salesman.
Every time he introduced a new mattress to us he'd walk over to the mattress and slap it like a car salesman would slap
a car, and say something like "This tempurpedic mattress has patented cooling technology." Best hour and a half of my life.

<br/>

{/* 

[every single shitpost I've ever written]
[things that have happened]
[tag idk]
[things I have done to my little sister, aka tabasco sauce on toothbrush]
[mountain brauhaus]
[the quietest place on earth[throne hike]]
[bee flying into ear]
[random people I've met. I met a very nice guy at mattress firm the other day who has been working there for six months]
[jumping on the back of a moving train because I'm a dumbass]
[every single fever dream I've had while I was food poisoned]
[the most beautiful lady I ever met worked at a gift shop in tokyo tower]
[Going down a rabbit hole of building hacking at HCSSiM[aka an unnamed math program]]
[the story of how I started doing things in Desmos]
[meeting john conway]
[seeing a squirrel eating a bird after feeling vengeful] */}
<br/>
<br/>
<br/>
<br/>
                            
</div>;